import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Register } from '@app/utils/type-registry';
import { ProgressBarInput, ProgressBarOutput } from '@trackback/widgets';
import { CommonModule } from '@angular/common';
import { BaseWidgetComponent } from '@app/widgets/base-widget.component';
import { ParsePipe } from '@app/pipes/parse.pipe';

@Register('progressbar')
@Component({
  selector: 'tb-progress-bar',
  template: `
    @let parsedHeight = (input.height | parse: context | async) + 'px';
    <mat-progress-bar
      [color]="input.color | parse: context | async"
      [mode]="input.mode | parse: context | async"
      [value]="input.value | parse: context | async"
      [bufferValue]="input.bufferValue | parse: context | async"
      [style]="{
        '--mdc-linear-progress-track-height': parsedHeight,
        '--mdc-linear-progress-active-indicator-height': parsedHeight,
      }"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, MatProgressBarModule, ParsePipe],
})
export class ProgressBarComponent extends BaseWidgetComponent<
  ProgressBarInput,
  ProgressBarOutput
> {}
